import { render, staticRenderFns } from "./SettingsCommercialClientsHPL.vue?vue&type=template&id=06d8efd4&scoped=true&"
import script from "./SettingsCommercialClientsHPL.vue?vue&type=script&lang=js&"
export * from "./SettingsCommercialClientsHPL.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCommercialClientsHPL.vue?vue&type=style&index=0&id=06d8efd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8efd4",
  null
  
)

export default component.exports